import React from "react";
import classes from "../Assets/Styles/Footer.module.css";
import { Box, Container, Typography } from "@mui/material";
import { companyName } from "../utils/constants";

const formatCompanyName = (name) => {
  const trimmedName = name.trim();
  return trimmedName.endsWith(".") ? trimmedName : `${trimmedName}.`;
};

const Footer = ({ loading }) => {
  return (
    <>
      <Box className={classes["footer"]} component="footer" id="footer">
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Typography
                variant="body1"
                marginTop={2}
                fontFamily={"Livvic"}
                sx={{ color: "var(--color-topbar-text)" }}
            >
              &copy; {new Date().getFullYear()} {formatCompanyName(
                companyName
              )} All rights reserved.
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Footer;
